import { User } from '../../users/models/user';
import { userSchema } from '../../users/models/user.schema';
import { patchUserPayloadSchema } from './patch.schema';

export type PatchUserPayload = Partial<User>;

export const patch = (payload: PatchUserPayload) => {
  return {
    endpoint: `/auth/user`,
    method: 'PATCH',
    responseSchema: userSchema,
    payloadSchema: patchUserPayloadSchema,
    payload,
  } as const;
};
